module.exports = __webpack_public_path__ + "img/KitKat.6e9fea0e.webp";